module.exports = __webpack_public_path__ + "assets/img/seed_trace_module.74affc9d.png";